<template>
  <div class="tw-flex tw-w-full tw-h-full tw-flex-col">
    <div
      class="tw-flex tw-justify-between tw-p-[30px] tw-items-center tw-max-h-[95px] tw-h-[95px]"
    >
      <div
        id="chr-sheading-status"
        class="tw-text-[#211F58] tw-text-[18px] tw-font-semibold"
      >
        {{ getComponentUiText("app-manage-orgs-header-status-1") }}
      </div>
      <div
        :style="`border-radius: 7.566px; color: ${color}; background-color: ${backcroundColor};`"
        :class="`content__status tw-bg-[${backcroundColor}] tw-px-[10px] tw-pt-[12px] tw-pb-[10px] tw-font-medium tw-text-[${color}]`"
      >
        {{ status }}
      </div>
    </div>

    <div v-if="loading" class="custom-global-skeleton tw-w-full tw-h-full" />
    <div v-else class="tw-flex tw-w-full tw-h-full tw-justify-center tw-pt-9">
      <div class="wrapper" :style="`color: ${color};`">
        <div :class="`tw-text-[18px] content`">
          {{ text[0] }}
          <div v-if="text.length === 2" :class="`plus__minus`">
            {{ text[1] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
const props = defineProps({
  color: {
    type: String,
    default: "",
  },
  backcroundColor: {
    type: String,
    default: "",
  },
  status: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    default: "",
  },
  loading: {
    type: Boolean,
    default: true,
  },
});
</script>

<style lang="scss" scoped>
.content {
  font-family: Poppins;
  font-size: 163px;
  height: 117px;
  line-height: 130%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.plus__minus {
  position: absolute;
  font-size: 80px;
  top: -80px;
  right: 8px;

  font-family: Poppins;
}
.wrapper {
  width: 260px;
  position: relative;
}
.content__status {
  border-radius: 7.566px;
  line-height: 13px;
}
</style>
